export default __webpack_public_path__ + "static/media/noResultFound.9547d61c.png";